import { createSlice } from "@reduxjs/toolkit";
import { getAgencyCampaignList } from "./thunk";

export interface IState {
  lstPrepayment: any;
  isPrepaymentLoading: boolean;
  isPrepaymentSuccess: boolean;

  error: any;
}

export const initialState: IState = {
  lstPrepayment: null,
  isPrepaymentLoading: false,
  isPrepaymentSuccess: false,

  error: {},
};

const AgencySlice = createSlice({
  name: "Agency",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //get Advertisements
    builder.addCase(getAgencyCampaignList.pending, (state: IState, action: any) => {
      state.isPrepaymentLoading = true;
    });
    builder.addCase(
      getAgencyCampaignList.fulfilled,
      (state: IState, action: any) => {
        state.lstPrepayment = action.payload.data;
        state.isPrepaymentSuccess = true;
        state.isPrepaymentLoading = false;
      }
    );
    builder.addCase(
      getAgencyCampaignList.rejected,
      (state: IState, action: any) => {
        state.error = action.payload.error || null;
        state.isPrepaymentSuccess = false;
        state.isPrepaymentLoading = false;
      }
    );
  },
});

export default AgencySlice.reducer;